import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";

export const lsStylesFilterValStr = "styles_table_filter_obj";
export const lsFabricTrimsFilterValStr = "fab_trims_table_filter_obj";
export const lsBuyingFilterValStr = "buying_table_filter_obj";

export const hasRemarkFilter = {
	name: "Has Remark",
	key: "has_remark",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.BOOLEAN.key,
	constraints: { DISPLAY: true },
	[selectOptionsKeyName]: {
		type: arrType,
		list: [
			{ name: "Yes", key: "YES" },
			{ name: "No", key: "NO" },
		],
	},
};
